module.exports = __webpack_public_path__ + "static/img/clearing_white_01.1b671414.svg";